import React from "react";

/** Official WhatsApp brand glyph. Uses currentColor so parent controls colour. */
export default function WhatsAppIcon({ className = "h-5 w-5", title = "WhatsApp" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label={title}
      fill="currentColor"
    >
      <path d="M16.001 0h-.002C7.166 0 0 7.164 0 16c0 3.506 1.131 6.752 3.056 9.378L1.055 31.35l6.171-1.973A15.911 15.911 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16.001 0Zm9.302 22.596c-.385 1.088-1.916 1.99-3.136 2.253-.836.178-1.928.32-5.601-1.204-4.702-1.949-7.73-6.727-7.966-7.036-.226-.31-1.9-2.53-1.9-4.824 0-2.295 1.169-3.422 1.635-3.897.383-.39.834-.567 1.113-.567.278 0 .557.003.798.015.257.013.6-.098.937.716.385.936 1.313 3.23 1.428 3.464.116.234.194.507.039.816-.155.31-.233.505-.466.777-.234.272-.492.606-.702.816-.234.234-.478.487-.203.958.274.47 1.223 2.017 2.626 3.267 1.807 1.608 3.335 2.106 3.804 2.34.468.234.74.196 1.013-.116.272-.312 1.169-1.365 1.481-1.834.311-.468.623-.39 1.052-.234.427.156 2.718 1.282 3.184 1.516.468.234.78.351.896.545.116.194.116 1.127-.269 2.214Z"/>
    </svg>
  );
}
